import { defineNuxtRouteMiddleware, navigateTo } from '#imports';
import { useAuthStore } from '~/stores/auth';

/** Список и карточка документа без авторизации; /create — только с логином и пермишеном (см. page-permission на create.vue). */
function isPetsImportPublicRoute(path) {
  const base = '/rules/pets-import';
  if (path === base || path === `${base}/`) {
    return true;
  }
  if (!path.startsWith(`${base}/`)) {
    return false;
  }
  const firstSegment = path.slice(`${base}/`.length).split('/')[0];
  if (!firstSegment) {
    return false;
  }
  return firstSegment !== 'create';
}

export default defineNuxtRouteMiddleware(to => {
  const authStore = useAuthStore();

  // Public routes that must stay accessible without authentication.
  const publicPages = ['/login', '/forgot-password', '/api/auth/callback'];

  const isSearchAnimalPublicRoute = to.path.startsWith('/search/animals/');

  // Privacy policy is intentionally public (legal requirement).
  const isPrivacyPolicyPublicRoute = to.path.startsWith('/privacypolicy');

  const authRequired =
    !publicPages.includes(to.path) &&
    !isSearchAnimalPublicRoute &&
    !isPrivacyPolicyPublicRoute &&
    !isPetsImportPublicRoute(to.path);

  if (authRequired && !authStore.isAuthenticated) {
    return navigateTo('/login');
  }

  if (to.fullPath === '/') {
    return navigateTo('/owners'); // home page
  }
});
